import { render, staticRenderFns } from "./my-page.vue?vue&type=template&id=3f8014fe&"
import script from "./my-page.vue?vue&type=script&lang=js&"
export * from "./my-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports